import {relationGroupsConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { editRelationLoading : true, data: '', error: false};

export function editRelation(state = initialState, action) {
    switch (action.type) {
      case relationGroupsConstants.REQUEST_EDIT_RELATION:
        return {
          editRelationLoading: true,
          data: action.data,
          error: false
        };
      case relationGroupsConstants.RECEIVE_EDIT_RELATION:
      swal({
        text: 'Relations Updated Successfully',
        type: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK'
      })
        return {
          editRelationLoading: false,
          data: action.relation,
          error: false
        };
      case relationGroupsConstants.EDIT_RELATION_ERROR:
        return { 
          editRelationLoading: false,
          data: action.error,
          error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/relationGroups/editRelation.reducer.js